import React, { useEffect, useState } from 'react';

import { Col, Row } from 'antd';
import { NextPage } from 'next';
import getConfig from 'next/config';
import { connect } from 'react-redux';
import FooterColsConsumer from 'src/components/layout/FooterColsConsumer';
import { getFooter } from 'src/components/menu/Menu.utils';
import { IRootReducers } from 'src/reducers';
import { IMenu } from 'src/shared/models';
import { PlatformEnum } from '../../shared/enums';
import { config } from '../../../config/config';

const { RR_SS_FACEBOOK, RR_SS_INSTAGRAM } = getConfig().publicRuntimeConfig;

type Props = ReturnType<typeof mapStateToProps>;

const BasicPreFooterConsumer: NextPage<Props, {}> = ({
  publicMenu,
  privateMenu,
}) => {
  const [menu, setMenu] = useState<IMenu[]>(
    getFooter(false, publicMenu, privateMenu, false)
  );

  useEffect(() => {
    setMenu(getFooter(false, publicMenu, privateMenu, false));
  }, [publicMenu, privateMenu]);

  const getRRSSIcons = () => {
    return (
      <div className={`con-footer-app-menu__ss-icons`}>
        <a
          className="icon icon--facebook"
          href={RR_SS_FACEBOOK}
          target="_blank"
          rel="noreferrer"
        />
        <a
          className="icon icon--instagram"
          href={RR_SS_INSTAGRAM}
          target="_blank"
          rel="noreferrer"
        />
      </div>
    );
  };

  const complaintsBook = () => {
    const { PLATFORM, BASE_URL } = config.APP;

    if (PLATFORM === PlatformEnum.CON_PERU){
      return (
        <>
          <Row justify="center" align="middle">
            <Col>
              <a href={`${BASE_URL}/libro-de-reclamaciones`}>
                <img
                  src={`${BASE_URL}/icons/icon-libro-reclamaciones-form.png`}
                  alt="Libro de reclamaciones"
                  style={{
                    width: '120px',
                    marginTop: '10px',
                  }}
                />
              </a>
            </Col>
          </Row>
        </>
      );
    }

    return null;
  }

  const basicFooter = (
    <div className="pre-footer container--no-padding">
      <Row>
        {getRRSSIcons()}
        <div className="con-footer-app-menu__wrapper">
          <Row>{FooterColsConsumer(menu)}</Row>

          {complaintsBook()}
        </div>
      </Row>
    </div>
  );

  return basicFooter;
};

const mapStateToProps = (state: IRootReducers) => {
  return {
    userStatus: state.auth.userStatus,
    publicMenu: state.app.publicMenu,
    privateMenu: state.app.userMenu,
  };
};

export default connect(mapStateToProps, null)(BasicPreFooterConsumer);
